import classNames from 'classnames';
import React from 'react';
import { COLOR_CIRCLE_SIZES, MEDIUM_COLOR_CIRCLE_SIZE } from './constants';
import './TierColorCircle.scss';

interface TierColorCircleProps {
    tierColor: string;
    colorCircleSize?: string;
    customClassNames?: string;
}

export const TierColorCircle = ({
    tierColor,
    colorCircleSize = MEDIUM_COLOR_CIRCLE_SIZE,
    customClassNames,
}: TierColorCircleProps) => {
    if (!COLOR_CIRCLE_SIZES.includes(colorCircleSize)) {
        throw new Error(`Invalid circle size: ${colorCircleSize}`);
    }

    const circleSizeClassNames = classNames(
        'eds-g-cell',
        'eds-g-cell--align-center',
        'tier-list-item--color',
        `tier-list-color-circle--${colorCircleSize}`,
        customClassNames,
    );

    return (
        <span
            className={circleSizeClassNames}
            style={{ backgroundColor: tierColor }}
            data-spec="tier-color"
        />
    );
};
